// extracted by mini-css-extract-plugin
export default {"mountPoint":"MobileGameplayBanner_mountPoint__VTf+2","container":"MobileGameplayBanner_container__BnawM","inner":"MobileGameplayBanner_inner__ocCnm"};